import { DateNavigator } from '@devexpress/dx-react-scheduler-material-ui';

export const DateNavigationOverlayComponent = (
  props: DateNavigator.OverlayProps
) => {
  return <DateNavigator.Overlay {...props}></DateNavigator.Overlay>;
};
